module.exports = __webpack_public_path__ + "img/unread.7a261937.svg";